import camelCase from 'lodash/camelCase';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdOperationsGeneralConfiguration } from '@jira/navigation-apps__constants/src/SidebarIdOperationsGeneralConfiguration.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { mergeTeamsRoute } from '@jira/router-routes__eoc-merge-teams-routes/src/mergeTeamsRoute.tsx';
import { opsSettingsLayout } from '@jira/platform__layouts-ops-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { mergeTeamsEntryPoint } from '@jira/eoc__merge-teams/src/mergeTeamsEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const mergeTeamsPageEntryPoint = createPageEntryPoint({
	main: mergeTeamsEntryPoint,
});

export const mergeTeamsRouteEntry: Route = createEntry(mergeTeamsRoute, () => ({
	group: 'eoc',
	layout: opsSettingsLayout,

	resources: [
		...getNavigationResources(),
		getConsolidationStateResource(),
		navigationSidebarGlobalResource,
	],
	entryPoint: () => mergeTeamsPageEntryPoint,

	navigation: {
		menuId: MenuIdSettings,
		sidebarId: SidebarIdOperationsGeneralConfiguration,
	},

	pageId: 'eoc-merge-teams',
	meta: {
		reporting: {
			id: 'eoc.merge-teams',
			packageName: camelCase('eoc-merge-teams'),
			teamName: 'Alexstrasza',
		},
	},
	// eslint-disable-next-line no-restricted-syntax
	component: ErrorPagesNotFound,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
